<template>
  <div class="AdminLoginWrap">
    <div class="AdminLoginBox">
      <p class="AdminLoginBox_tit"></p>
      <div>
        <label for = 'admin_login_ID'>아이디</label>
        <input
          type = "text"
          id = 'admin_login_ID'
          placeholder = "아이디를 입력해 주세요"
          v-model="formData.adminLoginID"
          maxlength="20"
          @keypress.enter="check_form" />
        <p>{{errorData.adminLoginIDError}}</p>
      </div>
      <div class="AdminLoginBox_pwBox">
        <label for = 'admin_password'>비밀번호</label>
        <input
          type = "password"
          id = 'admin_password'
          placeholder = "비밀번호를 입력해 주세요"
          v-model="formData.adminPassword"
          maxlength="20"
          @keypress.enter="check_form" />
        <p>{{errorData.adminPasswordError}}</p>
      </div>
      <button class="AdminLoginBox_btn" v-on:click="check_form">로그인 하기</button>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import {
  removeWhitespace,
  validateEngNum,
  validatePassword
} from '../../ETC/Validation.vue'
import {
  check_login_admin
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminLogin',
  setup () {
    return {
      formData: ref({
        adminLoginID: '',
        adminPassword: ''
      }),
      errorData: ref({
        adminLoginIDError: '',
        adminPasswordError: ''
      }),
      statusData: ref({
        adminLoginStatus: false,
        adminPasswordStatus: false,
        spinnerStatus: false
      })
    }
  },
  watch: {
    'formData.adminLoginID': function (value) {
      this.formData.adminLoginID = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.adminLoginIDError = '아이디는 필수로 입력해야 합니다.'
        this.statusData.adminLoginStatus = false
      } else if (removeWhitespace(value).length < 5) {
        this.errorData.adminLoginIDError = '아이디는 최소 6자 이상 입력해야 합니다.'
        this.statusData.adminLoginStatus = false
      } else if (validateEngNum(removeWhitespace(value))) {
        this.errorData.adminLoginIDError = ''
        this.statusData.adminLoginStatus = true
      } else {
        this.errorData.adminLoginIDError = '한글 및 특수문자는 입력할 수 없습니다.'
        this.statusData.adminLoginStatus = false
      }
    },
    'formData.adminPassword': function (value) {
      this.formData.adminPassword = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.adminPasswordError = '비밀번호는 필수로 입력해야 합니다.'
        this.statusData.adminPasswordStatus = false
      } else if (validatePassword(removeWhitespace(value))) {
        this.errorData.adminPasswordError = ''
        this.statusData.adminPasswordStatus = true
      } else {
        this.errorData.adminPasswordError = '최소 8자리/ 숫자, 특수문자 각 1회 이상을 입력해야 합니다.'
        this.statusData.adminPasswordStatus = false
      }
    }
  },
  methods: {
    check_form: function () {
      if (
        this.statusData.adminLoginStatus &&
        this.statusData.adminPasswordStatus
      ) {
        check_login_admin(
          this.formData.adminLoginID,
          this.formData.adminPassword
        ).then(result => {
          localStorage.setItem('activeMenu', '')
          if (result === 1) {
            window.location.href = '/AdminMain'
          } else {
            alert('아이디 또는 비밀번호를 확인해주세요.')
          }
        })
      } else {
        alert('아이디 및 비밀번호를 확인해주세요.')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Login/AdminLogin.vue